
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import { PvdModal } from 'pvd3/*';

declare let app: any;

export default defineComponent({
  name: 'FdicModal',
  data: function () {
    return {
      clientConstants: ClientConstants,
      fdicLink: ''
    };
  },
  methods: {
    openFdicModal() {
      const fdicModal = this.$refs['fdic-modal'] as PvdModal;
      fdicModal.pvdOpen = true;
    }
  },
  async mounted() {
    this.fdicLink = app ? `${app.fdicUrl}` : '';
  }
});
